import { Navigate, Outlet } from "react-router-dom";
import { Spinner } from "@fluentui/react-components";
import { useGetUserAccessLevel } from "../../hooks/useGetUserAccessLevel";

export function SystemAdminRouteGuard() {
  const accessLevel = useGetUserAccessLevel();

  if (accessLevel === -1) return <Spinner />;
  if (accessLevel < 5) return <Navigate to="/" replace />;
  return <Outlet />;
}
